<template>
    <v-list nav dense>
        <v-subheader class="pl-0">
            <v-hover v-slot:default="{ hover }">
                <v-btn small text color="grey darken-1" class="text-caption" @click="$emit('update:expanded', !expanded)">
                    ORGANIZATION
                    <v-icon v-if="hover" right small>{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
            </v-hover>
        </v-subheader>
        <v-expand-transition>
            <div v-show="expanded">
                <OrganizationMenu :collapsed="collapsed" :show-quick-actions="true" />

                <v-list-item
                    :class="{ 'ml-2 drawer-active-item': !collapsed }"
                    active-class="primary--text"
                    :to="{ name: 'home-spaces', params: { oid: currentOrgOid } }">
                    <v-list-item-icon>
                        <v-tooltip right :disabled="!collapsed">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">mdi-format-list-text</v-icon>
                            </template>
                            <span>Spaces</span>
                        </v-tooltip>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Spaces</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="canCreateSpaces && !collapsed" class="my-0">
                        <SpaceCreateMenu offset-x right nudge-top="16" @select="createSpaceAndApp">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn text small v-bind="attrs" v-on="on" @click.stop.prevent class="px-2" min-width="0">
                                    <v-icon small>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                        </SpaceCreateMenu>
                    </v-list-item-action>
                </v-list-item>

                <v-list-item
                    :class="{ 'ml-2 drawer-active-item': !collapsed }"
                    active-class="primary--text"
                    :to="{ name: 'home-dashboard', params: { oid: currentOrgOid } }">
                    <v-list-item-icon>
                        <v-tooltip right :disabled="!collapsed">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">mdi-view-dashboard-outline</v-icon>
                            </template>
                            <span>Overview</span>
                        </v-tooltip>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Overview</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </div>
        </v-expand-transition>
    </v-list>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

const OrganizationMenu = () => import('@/components/OrganizationMenu.vue')
const SpaceCreateMenu = () => import('@/components/SpaceCreateMenu.vue')

export default {
    name: 'DrawerOrganizationSection',
    components: {
        OrganizationMenu,
        SpaceCreateMenu
    },
    props: {
        collapsed: {
            type: Boolean,
            default: false
        },
        expanded: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapGetters('orgStore', ['isOrgManager', 'isOrgFaculty']),
        ...mapState(['userOrgs', 'currentOrgData']),
        currentOrgOid() {
            return this.$route.params.oid || this.currentOrgData?.oid || this.userOrgs[0]?.oid
        },
        canCreateSpaces() {
            return this.isOrgFaculty || this.isOrgManager
        }
    },
    methods: {
        createSpaceAndApp(type) {
            if (type === 'class') {
                this.$router.push({
                    name: 'home-add-class',
                    params: { oid: this.$route.params.oid }
                })
                return
            }

            if (type === 'research') {
                this.$router.push({
                    name: 'home-add-research-project',
                    params: { oid: this.$route.params.oid }
                })
                return
            }

            if (type === 'dataset') {
                this.$router.push({
                    name: 'home-add-dataset',
                    params: { oid: this.$route.params.oid }
                })
            }
        }
    }
}
</script>
